<a [href]="url" [target]="target" [style.color]="color" [style.background-color]="background">{{text}}</a>
